<template>
  <b-modal ref="event_modal" title="Event Details" size="lg" scrollable>
    <h3>{{ event.title }}</h3>
    <p class="text-muted mb-2">
      <i class="far fa-calendar-alt mr-2"></i>
      <span v-if="event.start == event.end">{{ event.start | moment('D.M.Y.') }}</span>
      <span
        v-else
      >{{ event.start | moment('D.M.Y.') }} - {{ event.end && event.end | moment('D.M.Y.')}}</span>
    </p>
    <p v-if="event.project" class="text-muted mb-2">
      <i class="far fa-folder-open mr-2"></i>
      <span v-if=" event.project.website">
        <a :href="event.project.website" target="_blank">{{ event.project.title }}</a>
      </span>
      <span v-else>{{ event.project.title }}</span>
    </p>
    <p v-if="event.organization" class="text-muted mb-2">
      <i class="far fa-building mr-2"></i>
      <span>{{ event.organization.name }}</span>
    </p>
    <p v-if="event.location" class="text-muted mb-2">
      <i class="fas fa-map-marker-alt mr-2"></i>
      <span>{{ event.location }}</span>
    </p>
    <p>{{ event.description }}</p>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="hideModal">Close</b-button>
      <div v-if="event.user_id == userId">
        <b-button variant="success" class="mr-2" @click.prevent="editEvent">
          <i class="fas fa-edit"></i>
          Edit
        </b-button>
        <b-button variant="danger" class="mr-2" @click.prevent="deleteEvent">
          <i class="fas fa-trash"></i>
          Delete
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters({
      userId: "auth/userId",
      event: "calendar/curEvent"
    })
  },
  methods: {
    ...mapActions({
      destroyEvent: "calendar/destroyEvent",
      fetchEvent: "calendar/fetchEventDetails"
    }),
    show() {
      this.$refs.event_modal.show();
    },
    editEvent() {
      this.hideModal();
      this.$emit("event-edit");
    },
    deleteEvent() {
      let vm = this;
      var response = confirm("Do you want to delete this event?");
      if (response) {
        this.destroyEvent()
          .then(res => {
            vm.hideModal();
            vm.makeToast(
              "success",
              "Deleted!",
              "Event " + res.title + " has been deleted!"
            );
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    hideModal() {
      this.$refs["event_modal"].hide();
      this.isError = false;
      this.sending = false;
    }
  }
};
</script>

<style>
</style>